import { Box, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import { cancelFlow_cancelResultClick, cancelFlow_offerResultClick } from 'services/analytics/trackers/cancelFlow';

import { useModals } from 'hooks';

import SolidPaymentForm from 'components/SolidPaymentForm';
import Modal from 'components/Modal';
import { Button } from 'components/library';
import ContactUsLink from 'components/ContactUsLink';

import { WarningModalContainerProps } from './types';

const ErrorFeedbackModalContainer = ({
  title,
  subtitle,
  offerType,
  onMainBtnClick,
  analyticScreenLoadHandler,
  subscription_id,
  onSupportClick,
  withPaymentForm = false,
}: WarningModalContainerProps) => {
  const { t } = useTranslation();
  const { closeModal } = useModals();

  useEffect(() => {
    analyticScreenLoadHandler && analyticScreenLoadHandler();
  }, []);

  const handleClose = () => {
    if (offerType) {
      cancelFlow_offerResultClick({ action: 'close', result: 'fail', subscription_id, offer_type: offerType });
    }

    if (!offerType && subscription_id) {
      cancelFlow_cancelResultClick({ action: 'close', result: 'fail', subscription_id });
    }

    closeModal();
  };

  return (
    <Modal isOpen withCloseButton onClose={handleClose} dataLocator="subscriptionCancelationModalWarning">
      <Box $paddingTop={60} $paddingBottom={30} $paddingX={16}>
        <Text type="h1" center mb={20} >❗</Text>
        <Text type="h5" mb={24} center >{title}</Text>
        {subtitle && <Text center mb={24} >{subtitle}</Text>}
        {withPaymentForm ? (
          <SolidPaymentForm />
        ) : (
          <Button onClick={onMainBtnClick} mb={24}>
            {t('basics.tryAgain')}
          </Button>
        )}
        <ContactUsLink onSupportClick={onSupportClick} text={t('basics.contactSupport')} />
      </Box>
    </Modal>
  );
};

export default ErrorFeedbackModalContainer;
